import React from 'react';

export const useProductTour = () => {
  const [showTourInitiation, setShowTourInitiation] = React.useState(false);
  const [showTourSkipped, setShowTourSkipped] = React.useState(false);
  const [isTourActive, setIsTourActive] = React.useState(false);

  // Remove auto-trigger useEffect completely - tour will only start manually

  const startTour = () => {
    setShowTourInitiation(false);
    setIsTourActive(true);
  };

  const skipTour = () => {
    setShowTourInitiation(false);
    setShowTourSkipped(true);
    localStorage.setItem('product_tour_completed', 'true');
  };

  const completeTour = () => {
    setIsTourActive(false);
    localStorage.setItem('product_tour_completed', 'true');
  };

  const closeTourSkippedPopup = () => {
    setShowTourSkipped(false);
  };

  const resetTour = () => {
    localStorage.removeItem('product_tour_completed');
    setShowTourInitiation(true);
  };

  const showTourInitiationPopup = () => {
    const hasTakenTour = localStorage.getItem('product_tour_completed') === 'true';
    if (!hasTakenTour) {
      setShowTourInitiation(true);
    }
  };

  return {
    showTourInitiation,
    showTourSkipped,
    isTourActive,
    startTour,
    skipTour,
    completeTour,
    closeTourSkippedPopup,
    resetTour,
    showTourInitiationPopup
  };
};
